import _ from 'lodash'
import { ISpecification, SpecificationEntity, SpecificationTypeEntity, ISpecificationType } from "./types"

/**
 * Specification entity schema convert to model
 */
export function mapSpecificationFromEntity(specificationEntity: SpecificationEntity): ISpecification {
    return {
        id: specificationEntity.id,
        title: specificationEntity.title,
        specificationTypeId: specificationEntity.specificationTypeId,
        type: specificationEntity.type,
        key: specificationEntity?.key,
        order: specificationEntity?.order || 0,
        brandId: specificationEntity?.brandId || null,
        values: _.keys(specificationEntity.values || {}).map(key => ({ name: key, value: specificationEntity.values[key] })),
        createdBy: specificationEntity.createdBy,
        updatedBy: specificationEntity.modifiedBy,
        createdAt: specificationEntity.createdOn,
        updatedAt: specificationEntity.modifiedOn,
        status: specificationEntity.status
    }
}

/**
 * Specification model schema convert to entity
 */
export function mapSpecificationFromModel(specificationSchema: ISpecification): SpecificationEntity {
    return {
        id: specificationSchema?.id || "",
        title: specificationSchema.title,
        specificationTypeId: specificationSchema.specificationTypeId,
        brandId: specificationSchema.brandId,
        values: (specificationSchema.values || []).reduce((prev, item) => {
            return { ...prev, [item.name]: item.value }
        }, {}),
        key: specificationSchema.key,
        order: specificationSchema?.order || 0,
        createdBy: specificationSchema.createdBy,
        modifiedBy: specificationSchema.updatedBy,
        createdOn: specificationSchema.createdAt,
        modifiedOn: specificationSchema.updatedAt,
        status: specificationSchema.status
    }
}

/**
 * Specification type entity schema convert to model
 */
export function mapSpecificationTypeFromEntity(specificationTypeEntity: SpecificationTypeEntity): ISpecificationType {
    return {
        id: specificationTypeEntity.id,
        title: specificationTypeEntity.title,
        key: specificationTypeEntity.key,
        status: specificationTypeEntity.status
    }
}

/**
 * Specification type model schema convert to entity
 */
export function mapSpecificationTypeFromModel(specificationTypeSchema: ISpecificationType): SpecificationTypeEntity {
    return {
        id: specificationTypeSchema?.id || "",
        title: specificationTypeSchema.title,
        key: specificationTypeSchema.key,
        status: specificationTypeSchema.status
    }
}
